import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../Styles/Contact.css';
import img from '../images/home_bg1.jpg';

const Contact = () => {
    return (
        <div className="contact-page-container">
            {/* ✅ SEO Helmet */}
            <Helmet>
                <title>Contact Us | Groomwell Salon Hafeezpet</title>
                <meta
                    name="description"
                    content="Get in touch with Groomwell Salon Hafeezpet. Call us, visit our location above SBI Bank on Manjeera Pipeline Road, or drop us a message online. Open Mon–Sat, 9 AM–9 PM."
                />
                <meta
                    name="keywords"
                    content="contact Groomwell Salon Hafeezpet, salon phone number, salon address Hafeezpet, ladies beauty parlour near Miyapur, Hyderabad salon contact"
                />
                <meta property="og:title" content="Contact Groomwell Salon Hafeezpet" />
                <meta property="og:description" content="Find Groomwell Salon’s contact details, address, phone, and email. Located above SBI Bank, Vinayaka Nagar, Hafeezpet." />
                <meta property="og:image" content="https://www.groomwellsalon.in/GROOMWELLINTERIOR.jpg" />
                <meta property="og:url" content="https://www.groomwellsalon.in/contact" />
                <link rel="me" href="https://www.instagram.com/groomwellsalon/" />
            </Helmet>

            <div className="left-column">
                <div className="contact-details">
                    {/* Address */}
                    <div className="detail-item">
                        <span className="icon">📍</span>
                        <div className="info-block">
                            <span className="info-label">Address</span>
                            <p className="info-text">
                                1-115/99(P)87, Manjeera Pipeline Rd, above SBI BANK, Vinayaka Nagar, Hafeezpet, Miyapur, Hyderabad, Telangana 500049
                            </p>
                        </div>
                    </div>
                    <div className="detail-divider"></div>

                    {/* Contact + Hours */}
                    <div className="contact-row">
                        <div className="detail-item">
                            <span className="icon">📞</span>
                            <div className="info-block">
                                <span className="info-label">Get in Touch</span>
                                <p className="info-text">+91 63048 35560</p>
                                <p className="info-text">groomwellsalon.co.in@gmail.com</p>
                            </div>
                        </div>

                        <div className="detail-item">
                            <span className="icon">⏰</span>
                            <div className="info-block">
                                <span className="info-label">Hours</span>
                                <div className="hours-text">
                                    <p>Mon – Sat : <span>9:00 am to 9:00 pm</span></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="detail-divider"></div>
                </div>

                {/* Contact Form */}
                <div className="form-section">
                    <h2 className="form-title">Leave A Reply</h2>
                    <form className="contact-form">
                        <div className="form-inputs">
                            <input type="text" name="name" placeholder="Name" />
                            <input type="email" name="email" placeholder="E-mail" />
                        </div>
                        <textarea name="message" placeholder="Message"></textarea>
                        <button type="submit" className="send-message-btn">Send Message</button>
                    </form>
                </div>
            </div>

            {/* Right Side */}
            <div className="right-column">
                <div className="image-section">
                    <img src={img} alt="Salon treatment Hafeezpet" />
                </div>
                <div className="map-section">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8264.98041404794!2d78.356504!3d17.485608!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb930026725dab%3A0x8987ca83de170111!2sGROOM%20WELL!5e1!3m2!1sen!2sin!4v1756923877774!5m2!1sen!2sin"
                        width="100%"
                        height="100%"
                        style={{ border: '0', borderRadius: '8px' }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Groomwell Salon Location on Google Maps">
                    </iframe>
                </div>
            </div>
        </div>
    );
};

export default Contact;
